import { PayloadAction } from '@reduxjs/toolkit';
import { PublicAssetAbstractProductData, PublicAssetProductState } from '../types';

const setPublicAssetProductDataReducer = (
  state: PublicAssetProductState,
  action: PayloadAction<PublicAssetAbstractProductData>,
) => {
  state.publicAssetAbstractProductData = action.payload;
  // Reset abstract products on new page load
  state.abstractProducts = {};
};

export default setPublicAssetProductDataReducer;
